import React from "react";

/**
 * ECLDialogModalButtonBar component renders a button bar with Confirm and Cancel buttons.
 * The buttons will close the dialog and call the provided handleConfirm function.
 *
 * @component
 * @example
 * const handleConfirm = () => { console.log("Confirmed"); };
 * return (
 *   <ECLDialogModalButtonBar handleConfirm={handleConfirm} />
 * );
 *
 * @param {Object} props - (required) Component props
 * @param {function} props.toggle - (required) Function to toggle display of modal
 * @param {function} props.action - (optional) Function to run on confirm button click
 * @param {function} props.cancelAction - (optional) Function to run on cancel button click
 * @param {Object} props.customButtons - (optional) Object to add custom buttons {"Hello": () => {console.log("Hello")}}
 * @param {bool} props.persist - (optional) If set to true, the confirm button will not close the modal, must close the modal by using the x
 * @param {string} props.confirmText - (optional) Text for the confirm button
 * @param {string} props.cancelText - (optional) Text for the cancel button
 * @param {bool} props.mandatory - (optional) If true, the cancel button will not be displayed
 */
export default function ECLDialogButtonBar({
   mandatory,
   toggle,
   action,
   cancelAction,
   customButtons,
   persist,
   confirmText,
   cancelText,
}) {
   const onConfirm = () => {
      if (action) {
         action();
      }
      if (!persist) {
         toggle();
      }
   };
   const onCancel = () => {
      if (cancelAction) {
         cancelAction();
      }
      toggle();
   };

   function customButtonAction(objectFunction) {
      objectFunction();
      if (!persist) {
         toggle();
      }
   }

   let buttonBar;
   if (!customButtons) {
      buttonBar = (
         <>
            <button onClick={onConfirm}>
               {confirmText ? confirmText : "Confirm"}
            </button>
            {!mandatory && (
               <button onClick={onCancel}>
                  {cancelText ? cancelText : "Cancel"}
               </button>
            )}
         </>
      );
   } else {
      if (Object.entries(customButtons).length > 0) {
         buttonBar = (
            <>
               {Object.entries(customButtons).map(
                  ([buttonText, buttonFunction]) => {
                     return (
                        <button
                           key={buttonText}
                           onClick={() => {
                              customButtonAction(buttonFunction);
                           }}
                        >
                           {buttonText}
                        </button>
                     );
                  },
               )}
               <button onClick={onCancel}>
                  {cancelText ? cancelText : "Cancel"}
               </button>
            </>
         );
      } else {
         buttonBar = null;
      }
   }

   return <div className="modal-button-bar">{buttonBar}</div>;
}
